import { Injectable, computed, signal } from '@angular/core';

/**
 * Global busy indicator.
 *
 * The previous app tracked loading with a manual counter seeded to the number of
 * collections its auth bootstrap subscribed to (`setLoaderCounter(8)`). That coupled
 * the spinner to one specific eager fan-out and was wrong the moment loading became
 * lazy. This is a plain reference count instead: whoever starts work ends it.
 */
@Injectable({ providedIn: 'root' })
export class LoaderService {
  private readonly pending = signal(0);

  readonly isLoading = computed(() => this.pending() > 0);

  start(): void {
    this.pending.update((n) => n + 1);
  }

  stop(): void {
    // Clamped: an unbalanced stop() must not drive the count negative and wedge the
    // indicator off for every subsequent operation.
    this.pending.update((n) => Math.max(0, n - 1));
  }

  reset(): void {
    this.pending.set(0);
  }
}
